export default __webpack_public_path__ + "static/media/flashingarc8.c3f75a1b.png";